import { useGetAreaBlocksQuery } from 'features/documents/documents';
import { AreaContext } from 'pages/documents_v2/views/edit_area/context/AreaContext';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

const emptyArray = [];

export function useGetAreaBlocks(returnResults = false) {
    const { areaId } = useParams();
    const { activeVariantId } = useContext(AreaContext);

    const results = useGetAreaBlocksQuery(
        { areaId: parseInt(areaId), variantId: activeVariantId },
        {
            selectFromResult: ({ currentData, isUninitialized, isFetching }) => ({
                areaData: currentData ?? {
                    id: undefined,
                    areaBlocks: emptyArray,
                },
                isLoading: isUninitialized || (isFetching && !currentData),
            }),
            skip: activeVariantId === 0,
        },
    );

    if (returnResults) {
        return results;
    }

    return results.areaData;
}
